import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameScene } from "./scenes/gameScene";

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(CameraAnimation)'
interface CameraAnimationDemoProps {
}

interface CameraAnimationDemoState {
}


const config: GameConfig = {
    title: "Camera Animations",
    version: "0.0.1-superAlpha",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 }
        }
    },
    backgroundColor: "#000000"
};

class PhaserCameraAnimationDemo extends React.Component<CameraAnimationDemoProps, CameraAnimationDemoState> {
    private game: Phaser.Game;
    constructor(props: CameraAnimationDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserCameraAnimationDemo.prototype);

        // You are allowed to set defaults here, based on your state object above
        this.state = {
        };
    }
    render() {
        return (<div>
            <PhaserGameComponent scenes={GameScene} config={config} />
        </div>);
    }
}

export default PhaserCameraAnimationDemo;



// WEBPACK FOOTER //
// ./src/games/demos/phaserCameraAnimationDemo/Main.tsx